<template>
    <div v-if="visible" class="loading-wrap">
        {{visible+''}}
        <!-- <div class="loading-box"><img src="@/assets/images/smilingFace.png" /></div> -->
        <div class="loading-box">
            <!-- <a-spin>
                <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
            </a-spin> -->
            <a-spin :indicator="indicator" style="color:#008dff;"/>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            visible: false,
            indicator: '<a-icon type="loading" style="font-size: 24px" spin />',
        };
    },
};
</script>
<style lang="less" scoped>
// @keyframes turn {
//     0% {
//         -webkit-transform: rotate(0deg);
//     }
//     25% {
//         -webkit-transform: rotate(90deg);
//     }
//     50% {
//         -webkit-transform: rotate(180deg);
//     }
//     75% {
//         -webkit-transform: rotate(270deg);
//     }
//     100% {
//         -webkit-transform: rotate(360deg);
//     }
// }
.loading-wrap {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    // background: rgba(39, 37, 37, 0.8);
    z-index: 99999999;
}
.loading-box {
    position: absolute;
    left: 50%;
    top: 50%;
    height: 40px;
    width: 40px;
    transform: translate(-50%, -50%);
    img {
        width: 100%;
        height: 100%;
        animation: turn 1s linear infinite;
    }
}

/deep/.ant-spin-dot-item{
    background: #008dff;
}
</style>



// WEBPACK FOOTER //
// src/serve/Loading/loading.vue